export const moderationLabels: Record<string, string> = {
  pending: "در انتظار بررسی",
  approved: "تأییدشده",
  rejected: "ردشده",
};
export const visibilityLabels: Record<string, string> = {
  unpublished: "منتشرنشده",
  published: "منتشرشده",
  hidden: "مخفی",
};
export const consentLabels: Record<string, string> = {
  notGranted: "اجازه نداده",
  granted: "اجازه داده",
  withdrawn: "اجازه پس گرفته شده",
};
export const replyLabels: Record<string, string> = {
  none: "بدون پاسخ",
  draft: "پیش‌نویس",
  published: "پاسخ منتشرشده",
};
export const sendLabels: Record<string, string> = {
  queued: "در صف",
  scheduled: "زمان‌بندی‌شده",
  dispatching: "در حال ارسال",
  sent: "ارسال‌شده (پذیرش اپراتور)",
  delivered: "تحویل‌شده",
  failed: "ناموفق",
  unknown: "نامشخص",
  cancelled: "لغوشده",
};
export const blockerLabels: Record<string, string> = {
  FEATURE_DISABLED: "نظرخواهی برای این سالن فعال نیست.",
  REVIEW_PERMISSION_DENIED: "اجازه ارسال نظرخواهی ندارید.",
  MERCHANT_SITE_UNAVAILABLE:
    "سایت سالن آماده نیست؛ عنوان و زیردامنه را در تنظیمات کسب‌وکار کامل کنید.",
  TEMPLATE_UNAVAILABLE: "قالب پیامک در دسترس نیست.",
  TEMPLATE_CHANGED: "قالب پیامک تغییر کرده؛ پیش‌نمایش را دوباره دریافت کنید.",
  INVALID_RECIPIENT: "شماره مشتری معتبر نیست.",
  INSUFFICIENT_SMS_CREDIT: "اعتبار پیامکی کافی نیست.",
  SMS_PROVIDER_FAILURE: "ارسال پیامک ناموفق بود؛ هزینه برگشت داده می‌شود.",
  DISPATCH_UNCONFIRMED: "نتیجه ارسال مشخص نیست؛ ممکن است پیامک رسیده باشد.",
  INVITATION_EXPIRED: "مهلت دعوت تمام شده است.",
  INVITATION_CLOSED: "دعوت بسته شده است.",
  PREPARATION_FAILED: "آماده‌سازی پیامک ناموفق بود.",
  INVITATION_IN_PROGRESS: "ارسال قبلی هنوز در جریان است.",
  REVIEW_ALREADY_SUBMITTED: "مشتری نظر خود را ثبت کرده است.",
  RESEND_COOLDOWN: "فاصله مجاز ارسال مجدد نگذشته است.",
  RESEND_LIMIT_REACHED: "تعداد مجاز ارسال مجدد تمام شده است.",
};
export const blockerLabel = (code?: string | null) =>
  code ? blockerLabels[code] || code : "";
export function hasReviewAction(
  actions: string[] | null | undefined,
  ...names: string[]
) {
  return actions?.some((action) => names.includes(action)) ?? false;
}
export type ReviewApiError = {
  response?: {
    status?: number;
    data?: {
      message?: string;
      Message?: string;
      code?: string;
      fieldErrors?: Record<string, string[]>;
      retryAfterUtc?: string;
    };
  };
  message?: string;
};
export function reviewError(error: unknown) {
  const value = error as ReviewApiError;
  if (value.response?.data?.code === "VERSION_CONFLICT")
    return "اطلاعات توسط کاربر دیگری تغییر کرده است. اطلاعات تازه بارگیری شد؛ پیش از تلاش دوباره بررسی کنید.";
  if (value.response?.status === 403)
    return "اجازه انجام این عملیات را ندارید.";
  return (
    value.response?.data?.message ||
    value.response?.data?.Message ||
    value.message ||
    "ارتباط با سرور برقرار نشد. دوباره تلاش کنید."
  );
}
export const billingLabels: Record<string, string> = {
  notCharged: "بدون کسر هزینه",
  charged: "هزینه کسر شد",
  compensated: "هزینه برگشت داده شد",
};
// Still being prepared or sent; the status should be polled until it settles.
export const sendInProgress = (status?: string | null) =>
  status === "queued" || status === "scheduled" || status === "dispatching";
// The server answered and rejected the request (4xx except timeout), so nothing was done and a
// new user action may use a new Idempotency-Key. Network errors and 5xx leave the outcome unknown.
export function isDefinitiveRejection(error: unknown) {
  const status = (error as ReviewApiError | undefined)?.response?.status;
  return !!status && status >= 400 && status < 500 && status !== 408;
}
// Review states win over reply states that share a code ("published").
const auditStateLabels: Record<string, string> = {
  ...replyLabels,
  ...consentLabels,
  ...visibilityLabels,
  ...moderationLabels,
};
const auditReasonLabels: Record<string, string> = {
  personalData: "اطلاعات شخصی",
  abuse: "توهین یا سوءاستفاده",
  spamOrUnrelated: "هرزنامه یا نامرتبط",
  other: "سایر",
};
// Audit entries carry codes; show them as "from → to" in Persian, keeping unknown codes as-is.
export function auditLabel(entry: { action?: string | null; fromState?: string | null; toState?: string | null; reasonCode?: string | null }) {
  const state = (value?: string | null) => (value ? auditStateLabels[value] || value : "");
  const change = entry.fromState || entry.toState ? [state(entry.fromState), state(entry.toState)].filter(Boolean).join(" ← ") : entry.action || "";
  const reason = entry.reasonCode ? ` (${auditReasonLabels[entry.reasonCode] || entry.reasonCode})` : "";
  return change + reason;
}
